import { useAuth } from './use-auth-wrapper'

export function usePermissions() {
  const { perfil } = useAuth()

  // Verifica se o usuário tem permissão de admin ou gestor
  const canManageChurch = () => {
    if (!perfil) return false
    return perfil.is_admin || perfil.permissao === 'admin' || perfil.permissao === 'gestor'
  }

  // Verifica se é admin (is_admin ou permissao admin)
  const isAdmin = () => {
    if (!perfil) return false
    return perfil.is_admin || perfil.permissao === 'admin'
  }

  // Verifica se é gestor
  const isGestor = () => {
    if (!perfil) return false
    return perfil.permissao === 'gestor'
  }

  // Verifica se é líder
  const isLider = () => {
    if (!perfil) return false
    return perfil.permissao === 'lider'
  }

  // Verifica se é membro
  const isMembro = () => {
    if (!perfil) return false
    return perfil.permissao === 'membro'
  }

  // Verifica se tem uma permissão específica
  const hasPermission = (permission: 'admin' | 'gestor' | 'lider' | 'membro') => {
    if (!perfil) return false
    
    // Se for is_admin, tem todas as permissões
    if (perfil.is_admin) return true
    
    return perfil.permissao === permission
  }

  // Verifica se tem pelo menos uma das permissões especificadas
  const hasAnyPermission = (permissions: ('admin' | 'gestor' | 'lider' | 'membro')[]) => {
    if (!perfil || !perfil.permissao) return false
    
    // Se for is_admin, tem todas as permissões
    if (perfil.is_admin) return true
    
    return permissions.includes(perfil.permissao)
  }

  return {
    canManageChurch,
    isAdmin,
    isGestor,
    isLider,
    isMembro,
    hasPermission,
    hasAnyPermission,
    perfil
  }
}